module.exports = __webpack_public_path__ + "img/ing.87d19067.svg";